module.exports = __webpack_public_path__ + "img/v4.f3d311fc.png";